<template>
  <el-aside :style="{ width: width + 'px' }" id="resize">
    <el-menu
      :unique-opened="open"
      :collapse="isCollapse"
      router
      :default-active="$route.path"
      background-color="#f7f7f7"
    >
      <!-- background-color="#f7f7f7" #eef5f9 -->
      <sidebar-item :routes="routes" v-if="routes.length > 0"></sidebar-item>
    </el-menu>
  </el-aside>
</template>
<script>
/**
 * 侧边栏菜单组件
 * 功能：从 store 获取菜单递归渲染，支持拖拽调节宽度并同步 CSS 变量 --label-left/--label-width
 */
import sidebarItem from "./sidebarItem";
export default {
  components: { sidebarItem },
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isCollapse(val) {
      if (val) {
        this.width = 65;
      } else {
        this.width = 200;
      }
    },
  },
  data() {
    return {
      width: 200,
      open: true,
    };
  },
  created() {
    this.getMenuList();
  },
  computed: {
    /** 菜单路由列表，来自 store */
    routes() {
      return this.$store.getters.menuList;
    },
  },
  mounted() {
    this.dragControllerDiv();
  },
  methods: {
    /** 拉取菜单列表存入 store */
    getMenuList() {
      this.$store.dispatch("getMenuList");
    },
    dragControllerDiv() {
      // 保留this引用
      let data = this;
      let resize = document.getElementById("resize");
      resize.onmousedown = function (e) {
        // 颜色改变提醒
        let startX = e.clientX;
        resize.left = resize.offsetLeft;
        document.onmousemove = function (e) {
          // 计算并应用位移量
          let endX = e.clientX;
          let moveLen = endX - startX;
          startX = endX;
          data.width += moveLen;
          if (data.width < 200 && !data.isCollapse) {
            data.width = 200;
          }
          if (data.isCollapse) {
            data.width = 65;
          }
          // 当前窗口总宽度
          let ckwidth = window.screen.width;
          if (data.width == 200) {
            let boomm = ckwidth - data.width;
            document
              .getElementsByTagName("body")[0]
              .style.setProperty("--label-left", "200px");
            document
              .getElementsByTagName("body")[0]
              .style.setProperty("--label-width", boomm + "px");
          } else {
            let boomm = ckwidth - data.width;
            document
              .getElementsByTagName("body")[0]
              .style.setProperty("--label-left", data.width + "px");
            document
              .getElementsByTagName("body")[0]
              .style.setProperty("--label-width", boomm + "px");
          }
        };
        document.onmouseup = function () {
          // 颜色恢复
          resize.style.background = "";
          document.onmousemove = null;
          document.onmouseup = null;
        };
        return false;
      };
    },
  },
};
</script>
<style scoped>
#resize {
  cursor: w-resize;
  border: solid 1px #e6e6e6;
}
</style>
